import AppConstants from '../../../../config/app.constants';
import _ from 'lodash';

class OrdersController {
    /*@ngInject*/
    constructor(Auth, $state, User, $translate, $location, $q, Modal, $scope, BranchFundingSourceService, SetupService, DateUtil, AtmResidualService, $stateParams, DataCounter, $rootScope, FetchReactData, $timeout) {
        this.$translate = $translate;
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.$scope = $scope;
        this.Modal = Modal;
        this.FetchReactData = FetchReactData;
        this.$q = $q;
        this.$timeout = $timeout;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.$stateParams = $stateParams;
        this.AtmResidualService = AtmResidualService;
        this.DataCounter = DataCounter;
        this.countedResidualShipments = [];
        this.errorShipments = [];
        this.$rootScope = $rootScope;

        this.model = {
            branch: User.getUser().branchId,
            search: null,
            ATM: "",
            date: "",
            atmResidual: [],
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            stats: ['inProcess'],
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            dateRange: {},
            currencyFilter: 'ALL'
        }

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.completedPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.pendingPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.inProcessPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.errorPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.stats = {
            completed: 'completed',
            pending: 'pending',
            errors: 'errors',
            inProcess: 'inProcess'
        }

        this.exportLoading = {
            completed: false,
            pending: false,
            errors: false,
            inProcess: false
        };

        this.locationLists = [];
        this.locationData = "";
        this.amount = 0;
        this.shipmentInProcessData = [];
        this.cursor = 0;
        this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/orders');
    }

    setDateRangeOptions(date, dateRangeOption, modelVal) {
        let currentVaultDate = moment(date).format() || moment();
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadData();
                }
            },
            ranges: {
                'Running 45 Days': [
                    moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Year': [
                    moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    loadPermission() {
        this.acl = {};
        this.hasACL = {};

        [
            'branch_mgmt_orders'
        ].forEach((permissionKey) => {
            const aclList = this.User.getACL(permissionKey);
            this.acl[permissionKey] = Array.isArray(aclList) ? aclList : [];

            this.hasACL[permissionKey] = {};

            this.acl[permissionKey].forEach((permission) => {
                this.hasACL[permissionKey][permission] = true;
            });
        });
    }

    $onInit() {
        this.loadPermission();
        this.moment = moment;
        const transitionData = this.FetchReactData.getTransitionData();
        this.locationData = transitionData || this.DataCounter.getData();

        this.$q.all([
            this.SetupService.get(this.model.branch)
        ])
            .then((data) => {
                this.vaultDate = this.DateUtil.convertToDate(data[0].currentVaultDate);
                this.setDateRangeOptions(this.vaultDate, this.model.dateRangeOptions, 'dateRange');
                if (this.locationData && this.locationData.vaultDate && this.locationData.isRedirected) {
                    this.model.dateRangeOptions.startDate = moment(this.locationData.vaultDate).subtract(30, 'days').format('YYYY-MM-DD');
                    this.model.dateRangeOptions.endDate = moment(this.locationData.vaultDate).add(14, 'days').format('YYYY-MM-DD');
                }
                else {
                    this.model.dateRangeOptions.startDate = moment(this.vaultDate).subtract(30, 'days').format('YYYY-MM-DD');
                    this.model.dateRangeOptions.endDate = moment(this.vaultDate).add(14, 'days').format('YYYY-MM-DD');
                }
                const available = Array.isArray(data[0].availableCurrencyIds) ? data[0].availableCurrencyIds : [data[0].currencyId];
                this.currencyOptions = [{ id: 'ALL', name: this.$translate.instant('common.All') }]
                    .concat(available.map(id => ({ id, name: id })));
                this.model.currencyFilter = 'ALL';
            })
            .then(() => {
                this.getFundingSource('', 0)
                    .then((res) => {
                        if (this.$stateParams.id) {
                            this.model.fundingSource = {
                                Key: res.results[0].locationId + " | " + res.results[0].sourceName, Value: res.results[0].locationId, Id: res.results[0].id
                            }
                            this.model.search = this.$stateParams.id;
                            this.countedResiduals();
                            // this.errorShipmentList();
                        }
                        else {
                            this.model.search = null;
                        }
                        return res.results;
                    })
                    .then((fundingSourceData) => {
                        this.loadOrderHistory(fundingSourceData);
                    })
            })
            .catch((err) => {
                console.log(err);
            });
    }


    // Get fundingSource
    locationSearchObj = (searchKey) => {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    },
                    {
                        group: {
                            rules: [{
                                field: 'locationId',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'sourceName',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getFundingSource(searchKey, offset) {
        const defer = this.$q.defer();
        const loadLocationData = this.locationSearchObj(searchKey);
        this.BranchFundingSourceService.all(loadLocationData, offset, AppConstants.defaultPageLimit, this.customerId)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingLocationData(data.results);
                }
                else {
                    const locations = this.mappingLocationData(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
                defer.resolve(data)
            })
        return defer.promise;
    }

    mappingLocationData(locations) {
        return locations.map((data) => {
            return {
                Key: data.locationId + " | " + data.sourceName,
                Value: data.locationId,
                Id: data.id
            }
        });
    }

    countedResiduals() {

        if (!this.model.fundingSource) {
            this.countedResidualShipments = [];
            this.completedPagination.total = 0;
            return this.$q.resolve();
        }

        this.loading = true;
        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
        const currencyId = this.model.currencyFilter === 'ALL' ? null : this.model.currencyFilter;
        const isFromRedirect = this.locationData && this.locationData.isRedirected && this.locationData.orderNo;

        return this.AtmResidualService.orderHistory(this.model.branch, startDate, endDate, this.model.fundingSource.Id, this.customerId, this.model.search, (this.completedPagination.page - 1) * this.completedPagination.pageLimit, this.completedPagination.pageLimit, currencyId)
            .then((data) => {
                this.loading = false;
                this.countedResidualShipments = data.completedShipment;
                this.completedPagination.total = data.totalRecords;
                if (this.model.search && this.model.stats.length === 1 && (!this.countedResidualShipments || this.countedResidualShipments.length === 0)) {
                    if (this.cursor >= 2) return;
                    this.model.stats = [this.stats.pending];
                    this.cursor++;
                    return this.unpackedShipmentList();
                }

                if (this.countedResidualShipments) { this.cursor = 0; }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                if (!isFromRedirect) {
                    this.resetFilter();
                    this.resetData();
                } else {
                    // Clear redirect flag but keep the search value
                    if (this.locationData) {
                        this.locationData = this.DataCounter.setData();
                        this.FetchReactData.clearTransitionData();
                    }
                }
            })
    }

    loadData() {
        this.completedPagination.page = 1;
        this.pendingPagination.page = 1;
        this.inProcessPagination.page = 1;
        this.errorPagination.page = 1;
        this.model.search = this.model.search || null;

        const promises = [];
        if (this.model.stats.includes(this.stats.errors)) {
            promises.push(this.errorShipmentList());
        }
        if (this.model.stats.includes(this.stats.completed)) {
            promises.push(this.countedResiduals());
        }
        if (this.model.stats.includes(this.stats.pending)) {
            promises.push(this.unpackedShipmentList());
        }
        if (this.model.stats.includes(this.stats.inProcess)) {
            promises.push(this.shipmentInProcessList());
        }
        return this.$q.all(promises);
    }

    // Display sum of all cell value
    totalAmount() {
        this.model.actualLoadTotal = 0;
        this.model.crvTotal = 0;
        this.model.requestLoadTotal = 0;
        this.model.countedResidualTotal = 0;
        this.model.varianceTotal = 0;

        return this.countedResidualShipments.map((data, index) => {
            this.model.requestLoadTotal += data.amountLoadRequested ? data.amountLoadRequested : 0;
            this.model.actualLoadTotal += data.amountLoadActual ? data.amountLoadActual : 0;
            this.model.crvTotal += data.amountCRV ? data.amountCRV : 0;
            this.model.countedResidualTotal += data.amountCounted ? data.amountCounted : 0;
            this.model.varianceTotal += data.variance ? data.variance : 0;
        })
    }

    // redirect to items page
    goToItemHistory(trackingId) {
        this.$state.go('branchManagement.items', {
            id: trackingId,
        });
    }

    loadOrderHistory(data) {
        if (!this.locationData || !this.locationData.isRedirected) return;
        if (this.locationData.fundingSourceId) {
            const fundingSource = _.find(data, { id: this.locationData.fundingSourceId });
            if (fundingSource) {
                return this.applyOrderHistoryFundingSource(fundingSource);
            }
            return this.BranchFundingSourceService.get(this.locationData.fundingSourceId)
                .then((res) => this.applyOrderHistoryFundingSource(res.results))
                .catch(() => this.applyOrderHistoryFundingSource(data[0]));
        }
        return this.applyOrderHistoryFundingSource(data[0]);
    }

    applyOrderHistoryFundingSource(fundingSource) {
        this.model.fundingSource = {
            Key: fundingSource.locationId + " | " + fundingSource.sourceName,
            Value: fundingSource.locationId,
            Id: fundingSource.id
        }
        this.model.search = this.locationData.orderNo;
        if (this.locationData.isCounted) {
            this.model.stats = [this.stats.completed];
            return this.countedResiduals();
        }
        else if (this.locationData.isInProcess) {
            this.model.stats = [this.stats.inProcess];
            return this.shipmentInProcessList();
        }
        else {
            this.model.stats = [this.stats.pending];
            return this.unpackedShipmentList();
        }
    }

    pageChange() {
        const promises = [];
        if (this.model.stats.includes(this.stats.errors)) promises.push(this.errorShipmentList());
        if (this.model.stats.includes(this.stats.completed)) promises.push(this.countedResiduals());
        if (this.model.stats.includes(this.stats.pending)) promises.push(this.unpackedShipmentList());
        if (this.model.stats.includes(this.stats.inProcess)) promises.push(this.shipmentInProcessList());
        return this.$q.all(promises);
    }

    completedPageChange() {
        this.countedResiduals();
    }

    pendingPageChange() {
        this.unpackedShipmentList();
    }

    inProcessPageChange() {
        this.shipmentInProcessList();
    }

    errorPageChange() {
        this.errorShipmentList();
    }

    filterData() {
        this.model.search = this.model.search || null;
        this.completedPagination.page = 1;
        this.pendingPagination.page = 1;
        this.inProcessPagination.page = 1;
        this.errorPagination.page = 1;
        this.loadData();
    }

    // load data of shipment request error (SHIPMENTREQUEST.result = 'error') 
    errorShipmentList() {

        if (!this.model.fundingSource) {
            this.errorShipments = [];
            this.errorPagination.total = 0;
            return this.$q.resolve();
        }

        this.model.loading = true;
        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY/MM/DD');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY/MM/DD');
        const currencyId = this.model.currencyFilter === 'ALL' ? null : this.model.currencyFilter;

        return this.AtmResidualService.errorShipmentList(this.model.branch, this.model.fundingSource.Id, startDate, endDate, this.model.search, (this.errorPagination.page - 1) * this.errorPagination.pageLimit, this.errorPagination.pageLimit, currencyId)
            .then((data) => {
                this.model.loading = false;
                this.errorPagination.total = data.totalRecords;
                this.errorShipments = data.errorShipment;
            })
            .then(() => {
                this.resetFilter();
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
    }

    jumpToNextPage() {
        this.errorShipmentList();
    }

    tabSelection(selectedValue) {
        const hadActiveSearch = !!this.model.search;
        if (hadActiveSearch) {
            this.clearSearch();
        }

        const index = this.model.stats.indexOf(selectedValue);
        if (index === -1) {
            this.model.stats.unshift(selectedValue);
            
            if (hadActiveSearch) {
                // If there was an active search, reload all selected tabs to show all data
                this.loadData();
            } else {
                // Only fetch data for the newly selected tab
                this.model.search = this.model.search || null;
                if (selectedValue === this.stats.errors) {
                    this.errorPagination.page = 1;
                    this.errorShipmentList();
                } else if (selectedValue === this.stats.completed) {
                    this.completedPagination.page = 1;
                    this.countedResiduals();
                } else if (selectedValue === this.stats.pending) {
                    this.pendingPagination.page = 1;
                    this.unpackedShipmentList();
                } else if (selectedValue === this.stats.inProcess) {
                    this.inProcessPagination.page = 1;
                    this.shipmentInProcessList();
                }
            }
        } else {
            if (this.model.stats.length > 1) {
                this.model.stats.splice(index, 1);
                if (hadActiveSearch) {
                    // Reload remaining tabs if search was cleared during deselection
                    this.loadData();
                }
            }
        }
    }

    unpackedShipmentList() {
        var self = this;
        if (!self.model.fundingSource) {
            self.pendingPackShipments = {};
            self.pendingPagination.total = 0;
            return self.$q.resolve();
        }

        self.gettingUnPackedShp = true;
        var startDate = moment(self.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
        var endDate = moment(self.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
        const currencyId = self.model.currencyFilter === 'ALL' ? null : self.model.currencyFilter;

        return self.AtmResidualService.unpackedShipmentList(self.model.branch, startDate, endDate, self.model.fundingSource.Id, self.customerId, self.model.search, self.pendingPagination.pageLimit, (self.pendingPagination.page - 1) * self.pendingPagination.pageLimit, currencyId)
            .then((data) => {
                self.pendingPackShipments = data;
                self.pendingPagination.total = data.totalRecords;
                if (this.model.search && this.model.stats.length === 1 && this.pendingPackShipments.results.length === 0) {
                    if (this.cursor >= 2) return;
                    this.model.stats = [this.stats.inProcess];
                    this.cursor++;
                    return this.shipmentInProcessList();
                }

                if (this.pendingPackShipments.results.length > 0) { this.cursor = 0; }
                this.resetFilter();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    self.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                self.gettingUnPackedShp = false;
                this.resetData();
            })
    }

    resetFilter() {
        if (this.locationData) {
            this.locationData.isRedirected = false;
            this.locationData = this.DataCounter.setData();
            this.FetchReactData.clearTransitionData();
        }
    }

    goToServiceHistory(locationId) {
        const obj = {
            locationId: locationId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    shipmentInProcessList() {
        var self = this;
        if (!self.model.fundingSource) {
            self.shipmentInProcessData = [];
            self.inProcessPagination.total = 0;
            return self.$q.resolve();
        }

        self.loadInProcessShpList = true;
        var startDate = moment(self.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
        var endDate = moment(self.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
        const currencyId = self.model.currencyFilter === 'ALL' ? null : self.model.currencyFilter;

        return self.AtmResidualService.shipmentInProcess(self.model.branch, startDate, endDate, self.model.fundingSource.Id, this.customerId, self.model.search, (self.inProcessPagination.page - 1) * self.inProcessPagination.pageLimit, self.inProcessPagination.pageLimit, currencyId)
            .then((data) => {
                self.shipmentInProcessData = data.results;
                self.inProcessPagination.total = data.totalRecords;
                if (this.model.search && this.model.stats.length === 1 && (!this.shipmentInProcessData || this.shipmentInProcessData.length === 0)) {
                    if (this.cursor >= 2) return;
                    this.model.stats = [this.stats.completed];
                    this.cursor++;
                    return this.countedResiduals();
                }

                if (this.shipmentInProcessData) { this.cursor = 0; }
                this.resetFilter();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    self.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                self.loadInProcessShpList = false;
                this.resetData();
            })
    }

    resetData() {
        if (this.cursor >= 2) {
            this.cursor = 0;
            this.model.search = null;
            this.model.stats = [this.stats.inProcess];
            this.loadData();
        }
    }

    clearSearch() {
        this.model.search = null;
    }

     downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
        document.body.removeChild(a);
    }

    exportToCSV(tab) {
        if (!this.model.fundingSource) {
            return;
        }

        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
        const currencyId = this.model.currencyFilter === 'ALL' ? null : this.model.currencyFilter;

        this.exportLoading[tab] = true;
        this.AtmResidualService.exportOrdersCSV(tab, this.model.branch, startDate, endDate, this.model.fundingSource.Id, this.customerId, this.model.search, currencyId)
            .then(data => {
                if (data.status && data.reportData) {
                    let fileName = "";
                    if (tab === this.stats.inProcess) {
                        fileName = `In_Process_Orders_${startDate}_to_${endDate}`;
                    } else if (tab === this.stats.completed) {
                        fileName = `Completed_Orders_${startDate}_to_${endDate}`;
                    } else if (tab === this.stats.pending) {
                        fileName = `Pending_Orders_${startDate}_to_${endDate}`;
                    } else if (tab === this.stats.errors) {
                        fileName = `Error_Orders_${startDate}_to_${endDate}`;
                    }
                    this.downloadFile(fileName, data.reportData);
                } else {
                    this.Modal.errorModal(data.message || "No records found to export.");
                }
            })
            .catch(err => {
                console.error(err);
                this.Modal.errorModal("An error occurred during export.");
            })
            .finally(() => {
                this.exportLoading[tab] = false;
            });
    }

    print(tab) {
        if (!this.model.fundingSource) {
            return;
        }

        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
        
        let obj = {
            branch: this.model.branch,
            startDate: startDate,
            endDate: endDate,
            fundingSourceId: this.model.fundingSource.Id,
            fundingSourceKey: this.model.fundingSource.Key,
            customerId: this.customerId,
            search: this.model.search,
            currencyFilter: this.model.currencyFilter,
            tab: tab,
            totalCount: (tab === this.stats.errors) ? this.model.pagination.total : this.pagination.total
        };

        let url = this.$state.href('printOrders');
        window.w = window.open(url, '_blank');
        window.w.printData = obj;
    }
}

export default OrdersController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/orders/orders.controller.js